import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useParams } from 'react-router-dom'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { CustomRenderColor, DeleteRow, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { TaskRepositoryTagModelType } from '@teinor/erp/types/company/task/taskRepository/taskRepositoryTag'
import ModalCETaskRepositoryTag from './ModalCETaskRepositoryTag'
import ModalDeleteTaskRepositoryTag from './ModalDeleteTaskRepositoryTag'

interface TaskRespositoryTagsProps extends ComponentWithPermissions { }

const TaskRespositoryTags: React.FC<TaskRespositoryTagsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('repositoryTags', 'Etiquetas de Repositorio'),
        newText: t('newTag', 'Nueva etiqueta'),
    }

    return (
        <BaseScreenTable TableComponent={TableTaskRespositoryTags} CreateModalComponent={ModalCETaskRepositoryTag} EditModalComponent={ModalCETaskRepositoryTag} DeleteModalComponent={ModalDeleteTaskRepositoryTag} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableTaskRespositoryTagsProps extends TableComponentProps { }

const TableTaskRespositoryTags: React.FC<TableTaskRespositoryTagsProps> = ({ setTableInstance, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { id } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(id || '')
    const columns: ColumnTableSchema<TaskRepositoryTagModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Name') }
            }
        },
        {
            id: 'color',
            dataKey: 'color',
            label: t('color', 'Color'),
            customRender: (parameterValue) => <CustomRenderColor value={parameterValue} />
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]

    return (
        <TwinTable name='TaskRepositoryTags' columns={columns} getDataFrom='/api/app/task/repository/tag/getAllTaskRepositoryTags' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} />
    )
}



export default TaskRespositoryTags